import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import api, { apiError } from "@/lib/api";
import { DashboardLayout } from "@/components/DashboardLayout";
import { Card, LoadingBlock, EmptyState } from "@/components/common";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { formatDate } from "@/lib/format";
import { Star, Eye, EyeOff } from "lucide-react";

export default function GestioneRecensioni() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ["admin-reviews"], queryFn: async () => (await api.get("/admin/reviews")).data });
  const reviews = data?.reviews || [];

  const moderate = async (id, status) => {
    try { await api.patch(`/admin/reviews/${id}?status=${status}`); toast.success("Recensione aggiornata."); qc.invalidateQueries({ queryKey: ["admin-reviews"] }); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <DashboardLayout title="Gestione recensioni">
      {isLoading ? <LoadingBlock /> : reviews.length === 0 ? <EmptyState title="Nessuna recensione" /> : (
        <div className="space-y-3">
          {reviews.map((r) => (
            <Card key={r.id} data-testid={`admin-review-${r.id}`} className="flex items-center justify-between gap-4">
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <div className="flex">{[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`h-4 w-4 ${n <= r.rating ? "text-[#D99A00] fill-[#D99A00]" : "text-[#D2E3DB]"}`} />)}</div>
                  <StatusBadge status={r.status === "published" ? "verificato" : "annullata"} label={r.status === "published" ? "Pubblicata" : "Nascosta"} />
                </div>
                <p className="text-sm text-[#5C6B68]">{r.comment || "(nessun commento)"}</p>
                <p className="text-xs text-[#5C6B68]/60 mt-1">{formatDate(r.created_at)}</p>
              </div>
              {r.status === "published" ? (
                <Button data-testid={`hide-${r.id}`} variant="outline" onClick={() => moderate(r.id, "hidden")} className="rounded-lg h-9 px-3 text-sm border-2 border-[#C0392B]/30 text-[#C0392B]"><EyeOff className="mr-1 h-4 w-4" /> Nascondi</Button>
              ) : (
                <Button data-testid={`show-${r.id}`} variant="outline" onClick={() => moderate(r.id, "published")} className="rounded-lg h-9 px-3 text-sm border-2 border-[#087A73] text-[#087A73]"><Eye className="mr-1 h-4 w-4" /> Pubblica</Button>
              )}
            </Card>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}
